module.exports = __webpack_public_path__ + "static/media/chinuri-green.ddae706e.png";